<script>
// FeedV2 production twin of the editor element: the spec carries only the ambient anchor
// in options.context; WHICH feed comes from the element's own PlatformFeedSelection option.
import DynamicAppFeedElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/DynamicAppFeedElement.vue";
import PlatformFeedSelection from "%/dynamic-components/render-engine/options/platform-feed-selection";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import LayoutGap from "%/dynamic-components/render-engine/options/layout-options/layout-gap";
import MaxWidth from "%/dynamic-components/render-engine/options/spacing-options/max-width";
import MinWidth from "%/dynamic-components/render-engine/options/spacing-options/min-width";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import AppFeedOptions from "~/dynamic-components/bundles/app-feed-options";

export default {
  name: "PlatformFeedElement",
  extends: DynamicAppFeedElement,
  elementPanelSettings: {
    displayName: "FeedV2",
    elementGroup: "general",
    displayIcon: "feed",
    elementType: "element",
  },
  // Re-declared in full: the palette merge only folds in the extended
  // component's MIXINS, not its own options/optionBundles arrays.
  optionBundles: [
    new AppearanceOptions({}, {}, false),
    AppFeedOptions,
  ],
  options: [
    PlatformFeedSelection,
    LayoutGap,
    MaxWidth,
    MinWidth,
    new LayoutWidth({
      "default": "fill",
    }),
  ],
  hidden: false,
  computed: {
    // The feed is the option-picked publication field, not a drop-time
    // stamp like the parent's elementContext.field.
    fieldName() {
      return this.getOptionValue(PlatformFeedSelection) || null;
    },
  },
};
</script>
